module.exports = __webpack_public_path__ + "static/img/kunjin-motors.61af550.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing/kunjin-motors.jpg
// module id = dvFl
// module chunks = 0